import { render, staticRenderFns } from "./homeFooter.vue?vue&type=template&id=b34db6e2&scoped=true"
import script from "./homeFooter.vue?vue&type=script&lang=js"
export * from "./homeFooter.vue?vue&type=script&lang=js"
import style0 from "./homeFooter.vue?vue&type=style&index=0&id=b34db6e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34db6e2",
  null
  
)

export default component.exports